module.exports = __webpack_public_path__ + "static/media/iommgp.bbea30b1.png";